module.exports = __webpack_public_path__ + "img/symbol_4.cdc5e72b.png";